import React, { useState } from "react";
import { Modal, Button, Icon, Dropdown } from "semantic-ui-react";
import RuvixxForm from "components/RuvixxForm";
import _ from "lodash";
import MachineService from "services/Machine";
import MachineApprovalStatusesService from "services/MachineApprovalStatus";
import RuvixxSelect from "components/RuvixxSelect";

const MachineStatusModal = ({
  machineStatusId,
  machineIds,
  machineStatusName,
  fetchFn,
  isDropdownButton,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStatusId, setSelectedStatusId] = useState(machineStatusId);

  const handleSubmit = async () => {
    await MachineService.updateStatus({
      machine_ids: machineIds,
      new_status_id: selectedStatusId,
    });
    fetchFn();
    handleClose();
  };

  const handleOpen = () => {
    setModalOpen(true);
    // Reset selected status to current status when opening modal
    setSelectedStatusId(machineStatusId);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  // Check if the selected status is the same as the current status
  const isStatusUnchanged = selectedStatusId === machineStatusId;

  return (
    <>
      <>
        {isDropdownButton ? (
          <Dropdown.Item onClick={handleOpen}>
            Change Machine Approval Status
          </Dropdown.Item>
        ) : (
          <>
            {machineStatusName ? (
              <>
                <strong style={{ color: "var(--color-text-primary)" }}>
                  {machineStatusName}
                </strong>
              </>
            ) : (
              <span style={{ color: "var(--color-text-muted)" }}>(unset)</span>
            )}
            <Button
              size="mini"
              icon="caret down"
              className="standard"
              style={{ marginLeft: "0.5em" }}
              onClick={handleOpen}
            />
          </>
        )}
      </>
      <Modal
        size="small"
        open={modalOpen}
        onOpen={handleOpen}
        onClose={handleClose}
        closeOnDimmerClick={false}
        closeIcon
        onFocus={e => e.stopPropagation()}
        onClick={e => e.stopPropagation()}
      >
        <Modal.Header content="Change Machine Approval Status" />
        <Modal.Content>
          <RuvixxForm
            onSubmit={handleSubmit}
            onCancel={handleClose}
            submitButtonText="APPLY"
            cancelButtonText="Cancel"
            submitButtonClassName=""
            cancelButtonClassName="basic"
            ready={!isStatusUnchanged}
          >
            <RuvixxSelect
              required={true}
              placeholder="Machine Approval Status"
              name="machine_approval_status"
              value={selectedStatusId}
              onChange={(_, data) => {
                setSelectedStatusId(data.value);
              }}
              queryFn={async _ => {
                return MachineApprovalStatusesService.getForFilters({});
              }}
              className="or-filter"
            />
            {isStatusUnchanged && (
              <div
                style={{ marginTop: "1em", color: "#888", fontSize: "0.9em" }}
              >
                The selected status is the same as the current status.
              </div>
            )}
          </RuvixxForm>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default MachineStatusModal;
